import { render, staticRenderFns } from "./winBulletinDetail.vue?vue&type=template&id=20ec3996&scoped=true"
import script from "./winBulletinDetail.vue?vue&type=script&lang=js"
export * from "./winBulletinDetail.vue?vue&type=script&lang=js"
import style0 from "./winBulletinDetail.vue?vue&type=style&index=0&id=20ec3996&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec3996",
  null
  
)

export default component.exports